import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import { TenantConfig } from '../../../data/models'
import {
  getCurrentTenantConfig,
  useCurrentTenantConfig,
} from '../../../utils/tenants'
import { PollingConfig } from './model'

// TODO: config kann nicht geladen werden, wenn im Header kein "Xia-ProjectId" vorhanden ist!
// Deswegen null als Argument in useSWR mitgeben wenn kein "Xia-ProjectId" nicht vorhanden ist.
export function useUiConfig(): FetchResult<TenantConfig> {
  const currentTenantConfig = getCurrentTenantConfig()
  const { data, isLoading, error, mutate } = useSWR<
    FetchResponse<TenantConfig>,
    FetchError
  >(
    `/config/ui`,
    !currentTenantConfig?.tenantId || !currentTenantConfig?.projectId
      ? null
      : fetchJson<TenantConfig>,
  )

  return {
    data: data?.body,
    isLoading: isLoading,
    error: error,
    mutate,
  }
}

export function usePollingConfig(): FetchResult<PollingConfig> {
  const currentTenantConfig = useCurrentTenantConfig()
  const { data, isLoading, error, mutate } = useSWR<
    FetchResponse<PollingConfig>,
    FetchError
  >(
    `/config/polling`,
    !currentTenantConfig?.tenantId || !currentTenantConfig?.projectId
      ? null
      : fetchJson<PollingConfig>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
